module.exports = __webpack_public_path__ + "img/section3-img1.2ecd0c53.jpg";